import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import {tableConfigListUser} from "../config";
import FlexView from "react-flexview";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import {defaultTableChange} from "../../../../../modules/custom/customTable";
import * as R from "ramda";

class CRMListUser extends Component {
    actionsButton = [
        {
            name: "employeeId",
            label: "Aksi",
            options: {
                customBodyRender: (val) => {
                    return (
                        <SimpleButton onClick={() => this.props.onSelectUser(val)}>
                            Pilih
                        </SimpleButton>
                    );
                },
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            tableConfig: [],
            dataTable: [],
            name: "",
            pagination: {
             limit: 5, 
             page: 1
            }
        };
    }

    componentDidMount() {
        this.setState((prevValue) => ({
            ...prevValue,
            tableConfig: [...tableConfigListUser, ...this.actionsButton],
            dataTable: this.props.listUser,
        }));
    }

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    filterUser = () => {
        const caseInsensitiveIncludes = (needle, haystack) =>
            haystack.toLowerCase().includes(needle.toLowerCase());

        let filteredUser;

        if (R.isEmpty(this.state.name)) {
            filteredUser = this.props.listUser;
        } else {
            filteredUser = this.props.listUser.filter(
                (user) =>
                    caseInsensitiveIncludes(this.state.name, user.name) ||
                    caseInsensitiveIncludes(this.state.name, user.userName)
            );
        }
        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: filteredUser,
        }));
    };

    handleChangePage = (tableState) => {
       this.setState((prevValue) => ({
           ...prevValue,
           pagination:{
               ...prevValue.pagination,
               page: tableState.page + 1,
           }
       }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <SimpleModal
                title="List User"
                visible={this.props.visible}
                onClickClose={this.props.onClickClose}
                styles={{width: "50%"}}
                content={
                    <ModalContainer>
                        <FlexView>
                            <SimpleInput
                                name="name"
                                label="Nama User"
                                value={this.state.name}
                                onChange={({target}) =>
                                    this.handleValueChange(target.name, target.value)
                                }
                            />
                            <SimpleButton
                                styles={{marginTop: "27px"}}
                                onClick={this.filterUser}
                            >
                                Cari
                            </SimpleButton>
                        </FlexView>
                        <SimpleDataTable
                            key={`${this.state.dataTable.length}-${this.state.pagination.page}`}
                            data={this.state.dataTable}
                            columns={this.state.tableConfig}
                            options={{
                              ...defaultTableChange(
                                this.handleChangePage,
                                this.handleRowsPerPage,
                              ),
                              serverSide: false,
                            }}
                            toCount={this.state.dataTable.length}
                            rowsPerPage={this.state.pagination.limit}
                            page={this.state.pagination.page - 1}
                        />
                    </ModalContainer>
                }
            />
        );
    }
}

export default CRMListUser;
